import { Component, OnInit, Input, Inject, OnChanges, Output, EventEmitter, DOCUMENT } from '@angular/core';


import { DialogUploadComponent, DialogUploadData } from '../dialog/dialog-upload.component';
import { DialogViewComponent, IDialogViewData } from '../dialog/dialog-view.component';
import { DialogConfirmDeleteComponent } from '../dialog/dialog-confirm-delete.component';

import { AppSheetHelpComponent } from '../../chrome/app-sheet-help.component';

import { base64StringToBlob, blobToBase64String } from 'blob-util';

import {
  AuthenticationService,
  ApprovalTaskItemApiService, AnnotationApiService, BlobApiService
} from '../../data-services/index';

import {
  IApplication, IApprovalTask, IApprovalTaskItem,
  IApprovalTaskItemInput, IAnnotationInput, IHelp, IUser
} from '@ebb-v2/ebb-integration';

import { DeviceDetectorService } from 'ngx-device-detector';
import { MatBottomSheet } from '@angular/material/bottom-sheet';
import { MatDialog } from '@angular/material/dialog';
import { cloneDeep } from 'lodash';

export interface IFileListDisplayItem {
  id: string;
  name: string;
  statusCode: number;
  statusCodeOptionSet: string;
  typeCode: number;
  typeCodeOptionSet: string;
  reasonWhy: string;
  payload: string;
  submissionReject: number;
  fileList: IFileListDisplayItemPayload[];
}

export interface IFileListDisplayItemPayload {
  payloadId: string;
  payloadName: string;
  ebbModifiedByTypeOptionSet: string;
  ebbModifiedDate?: Date;
}

export interface IFileListDisplayItemUpdate {
  id: string;
  disabled: boolean | true;
}

@Component({
    selector: 'ebb-portal-file-list',
    templateUrl: './file-list.component.html',
    standalone: false
})
export class FileListComponent implements OnInit, OnChanges {
  @Input('context') context: string;
  @Input('title') title: string;
  @Input('application') application: IApplication;
  @Input('task') task: IApprovalTask;
  @Input('disable') disableOverride: boolean;
  @Output() emitFileUploadEvent = new EventEmitter<IApprovalTask>();

  public currentUser: IUser;

  public taskItems: IApprovalTaskItem[] = [];
  public taskList: IFileListDisplayItem[] = [];

  public waitForFilesToShow: number;
  public waitForFileToUpload = -1;
  public autoSaveIndicator = false;
  public fileUrl: any;
  public innerWidth: number;

  constructor(
    private readonly dialogUpload: MatDialog,
    private readonly deviceService: DeviceDetectorService,
    private readonly dialogView: MatDialog,
    private readonly dialogConfirmDelete: MatDialog,
    private readonly infoSheet: MatBottomSheet,
    private readonly authenticationService: AuthenticationService,
    private readonly apiApprovalTaskItem: ApprovalTaskItemApiService,
    private readonly apiAnnotation: AnnotationApiService,
    private readonly apiblob: BlobApiService,
    @Inject(DOCUMENT) private document: Document
  ) {}

  ngOnInit() {
    this.currentUser = this.authenticationService.currentUserValue;
    this.taskItems = this.buildFiles(this.task.approvalTaskItems);
    this.loadSubmittedFiles();
    this.innerWidth = window.innerWidth;
  }

  ngOnChanges() {
    this.currentUser = this.authenticationService.currentUserValue;
    this.taskItems = this.buildFiles(this.task.approvalTaskItems);
    this.loadSubmittedFiles();
  }

  public loadSubmittedFiles(): void {
    this.waitForFilesToShow = 0;
  }

  // 1: Submitted Read-only; 2: Contractor Read-only; 3: ALL Edit
  public checkUploadAuthorization(item: IFileListDisplayItem): number {
    const retVal = 3;
    if (this.disableOverride === true) {
      return 1;
    }

    if (
      (this.application.stageCode === 700000000 &&
        this.application.eventPreliminaryReview === true) ||
      (this.application.stageCode === 700000001 &&
        (this.application.eventApplicationSubmitted === true ||
          this.context === 'PreRetrofit')) ||
      this.application.stageCode >= 700000002
    ) {
      if (
        (item.submissionReject > 0 ||
          item.statusCode === 700000000 ||
          item.statusCode === 700000002 ||
          ((this.application.stageCode === 700000000 ||
            this.application.stageCode === 700000001) &&
            item.statusCode === 700000003 &&
            this.taskItems.find(element => element.submissionReject > 0) !==
              undefined)) &&
        (this.isHomeowner() ||
          (this.isContractor() &&
            this.application.contractorPermissionsCode === 700000001))
      ) {
        return 3;
      }
      return 1;
    }

    if (
      this.isContractor() &&
      (this.application.contractorPermissionsCode === 700000003 ||
        this.application.contractorPermissionsCode === 700000002)
    ) {
      return 2;
    }

    return retVal;
  }

  public onUploadFileEvent(
    payload: string,
    itemId: string,
    itemTypeCode: string,
    attachmentName: string = ''
  ): void {
    const dialogUploadDataItem: DialogUploadData = {} as DialogUploadData;
    dialogUploadDataItem.isImage = false;
    dialogUploadDataItem.attachmentName = attachmentName;

    const dialogRef = this.dialogUpload.open(DialogUploadComponent, {
      width: '400px',
      data: dialogUploadDataItem
    });

    dialogRef.afterClosed().subscribe(result => {
      if (itemId && itemId.length > 0) {
        if (result && result.uploadFileName.length > 0) {
          const index = this.taskItems.findIndex(i => i.id === itemId);
          const updatedItem = this.taskItems[index];

          const fileName = result.uploadFileName.replace(/[;,/?:@&=+$]/g, '');
          updatedItem.payloadName = fileName;

          // const indexToUpdate = this.taskListUpdate.findIndex(i => i.id === itemId);
          // this.taskListUpdate[indexToUpdate].disabled = false;

          this.waitForFileToUpload = index;
          this.autoSaveIndicator = true;

          const modifyItem: IApprovalTaskItemInput = {} as IApprovalTaskItemInput;
          modifyItem.id = updatedItem.id;
          modifyItem.deferUpdate = 700000001;
          modifyItem.payloadName = fileName;
          this.apiApprovalTaskItem
            .saveItem(
              modifyItem,
              this.application.id,
              updatedItem._Ebb_ApprovalTaskId
            )
            .subscribe(() => {
              blobToBase64String(result.uploadFile)
                .then(base64string => {
                  const fileString64 = base64string;
                  const annotationInput: IAnnotationInput = {
                    id: payload,
                    _Objectid_Value: this.taskItems[index].id,
                    objectTypeCode: 'cea_approvaltaskitem',
                    fileName: fileName,
                    fileSize: result.uploadFile.size,
                    mimeType: result.uploadFile.type,
                    subject: fileName,
                    noteText: '',
                    documentBody: fileString64
                  };

                  this.apiAnnotation
                    .saveAnnotation(annotationInput)
                    .subscribe(data => {
                      const annotation = data;
                      const newPayload = data.id;
                      updatedItem.payload = newPayload;
                      this.apiApprovalTaskItem
                        .getItem(updatedItem.id)
                        .subscribe(data => {
                          const index = this.task.approvalTaskItems.findIndex(
                            i => i.id === data.id
                          );
                          this.task.approvalTaskItems[
                            index
                          ] = data as IApprovalTaskItem;
                          this.task.approvalTaskItems[
                            index
                          ] = this.setApprovalTask(
                            this.task.approvalTaskItems[index],
                            annotation
                          );
                          this.waitForFileToUpload = -1;
                          this.autoSaveIndicator = false;
                          this.emitFileUploadEvent.emit(this.task);
                          //this.ngOnInit();
                        });
                    });
                })
                .catch(err => {
                  console.warn('Unable to convert file');
                });
            });
        }
      } else {
        console.warn(`ERROR: Unable to upload file without ID`);
      }
    });
  }

  public onSaveRejectedTaskItem(itemId: string): void {
    const index = this.taskItems.findIndex(i => i.id === itemId);
    const updatedItem = this.taskItems[index];

    const modifyItem: IApprovalTaskItemInput = {} as IApprovalTaskItemInput;
    modifyItem.id = updatedItem.id;
    modifyItem.statusCode = 700000003;
    modifyItem.deferUpdate = 700000000;
    this.apiApprovalTaskItem
      .saveItem(
        modifyItem,
        this.application.id,
        updatedItem._Ebb_ApprovalTaskId
      )
      .subscribe(() => {
        this.apiApprovalTaskItem.getItem(modifyItem.id).subscribe(data => {
          const index = this.task.approvalTaskItems.findIndex(
            i => i.id === data.id
          );
          this.task.approvalTaskItems[index] = data as IApprovalTaskItem;
          this.taskItems = this.buildFiles(this.task.approvalTaskItems);
          this.waitForFileToUpload = -1;
          this.autoSaveIndicator = false;
          this.emitFileUploadEvent.emit(this.task);
          this.ngOnInit();
        });
      });
  }

  public onDeleteFileEvent(
    payloadId: string,
    payloadName: string,
    itemId: string
  ): void {
    const currentTaskItem: IApprovalTaskItem = this.taskItems.filter(
      i => i.id === itemId
    )[0];

    const dialogRef = this.dialogConfirmDelete.open(
      DialogConfirmDeleteComponent,
      {
        width: '400px',
        data: payloadName
      }
    );

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        // const indexToUpdate = this.taskListUpdate.findIndex(i => i.id === itemId);
        // this.taskListUpdate[indexToUpdate].disabled = false;

        this.autoSaveIndicator = true;
        if (currentTaskItem.id && currentTaskItem.id.length > 0) {
          this.apiAnnotation.deleteAnnotation(payloadId,this.application.id).subscribe(
            () => {
              this.autoSaveIndicator = false;
              this.emitFileUploadEvent.emit(this.task);
              //this.ngOnInit();
            },
            error =>
              console.warn(
                `ERROR: cannot delete annotation ${JSON.stringify(error)}`
              )
          );
        } else {
          console.warn(`ERROR: Unable to delete file without ID`);
        }
      }else{
     this.ngOnInit();
      }
    });
  }

  public onViewFileEvent(payloadId: string, payloadName: string): void {
    console.log(`onViewFileEvent(${payloadId}, ${payloadName})`);
    const dialogViewDataItem: IDialogViewData = {} as IDialogViewData;

    if (!payloadId && payloadId.length === 0) {
      return;
    } else {
      if (this.onCheckToView(payloadName)) {
        //iOS does not allow open blob file in another tab
        if (this.deviceService.isMobile()) {
          dialogViewDataItem.annotationId = payloadId;
          dialogViewDataItem.viewType = 2;
          dialogViewDataItem.title = payloadName;
          const dialogRef = this.dialogView.open(DialogViewComponent, {
            maxWidth: '95vw',
            maxHeight: '85vh',
            height: '700px',
            width: '1000px',
            data: dialogViewDataItem
          });
        } else {
          this.openImage(payloadId, payloadName);
        }
      } else {
        this.saveAsSubmittedFile(payloadId, payloadName);
      }
    }
  }

  public openImage(payloadId: string, payloadName: string): void {

    this.apiblob.getTaskFiles(payloadId, payloadName,1).subscribe(
      fileBlob => {
        // this.apiAnnotation.getAnnotation(payloadId).subscribe(
        //   data => {
        //     const fileBlob = base64StringToBlob(data.documentBody, data.mimeType);
        let navigator : any = window.navigator;
        if (navigator && navigator.msSaveOrOpenBlob) {
          navigator.msSaveOrOpenBlob(fileBlob, payloadName);
        } else {
          const linkToView = this.document.createElement('a');
          linkToView.href = window.URL.createObjectURL(fileBlob);
          linkToView.target = '_blank';
          linkToView.id = payloadName;
          document.body.appendChild(linkToView);
          linkToView.click();
          linkToView.remove();
        }
      },
      error => {
        console.warn(error);
      }
    );
  }

  private onCheckToView(payloadName: string): boolean {
    let retVal = false;
    if (payloadName && payloadName.length > 0) {
      const extension = payloadName.split('.').pop();
      switch (extension.toLowerCase()) {
        case 'jpg':
        case 'png':
          retVal = true;
          break;
        default:
          retVal = false;
      }
    }
    return retVal;
  }

  private saveAsSubmittedFile(payloadId: string, payloadName: string): any {
    //  let fileBlob: Blob = null;
    this.autoSaveIndicator = true;
    if (payloadId && payloadId.length > 0) {
      this.apiblob
        .getTaskFiles(payloadId, payloadName,1)
        .subscribe(
          fileBlob => {
            this.autoSaveIndicator = false;
            let navigator : any = window.navigator;
            if (navigator && navigator.msSaveOrOpenBlob) {
              navigator.msSaveOrOpenBlob(fileBlob, payloadName);
            } else {
              const downloadLink = this.document.createElement('a');
              downloadLink.href = window.URL.createObjectURL(fileBlob);
              downloadLink.download = payloadName;
              document.body.appendChild(downloadLink);
              downloadLink.click();
              downloadLink.remove();
            }
          },
          error => {
            console.warn(error);
          }
        );
    }
  }

  public formatNameToId(name: string): string {
    if(typeof name === 'string') {
      return 'file-' + name.toLowerCase().replace(/[^a-z0-9\-]/g,'');
    } else {
      return '';
    }
  }

  public lookupIndex(item: IApprovalTaskItem): number {
    return this.task.approvalTaskItems.findIndex(i => i.id === item.id);
  }

  public onClickShowReasonWhy(topic: string): void {
    const item: IHelp = {} as IHelp;
    item.question = 'Reason Why';
    item.answer = topic.replace(/(\r\n|\n|\r)/gm, '<br/>');
    this.infoSheet.open(AppSheetHelpComponent, { data: item });
  }

  private buildFiles(taskList: IApprovalTaskItem[]): IApprovalTaskItem[] {
    const ret: IApprovalTaskItem[] = [];
    this.taskList = [];

    taskList.forEach(item => {
      if (item.payloadTypeCodeOptionSet !== 'Form') {
        const taskItem: IFileListDisplayItem = {} as IFileListDisplayItem;
        taskItem.id = item.id;
        taskItem.name = item.name;
        taskItem.statusCode = item.statusCode;
        taskItem.statusCodeOptionSet = item.statusCodeOptionSet;
        taskItem.typeCode = item.typeCode;
        taskItem.typeCodeOptionSet = item.typeCodeOptionSet;
        taskItem.submissionReject = item.submissionReject;
        taskItem.reasonWhy = item.reasonWhy;
        taskItem.payload = item.payload;
        taskItem.fileList = [];

        if (item.payload && item.payload.toString().indexOf(',') > 0) {
          const idList = item.payload.toString().split(',');
          const nameList = item.payloadName.toString().split(',');
          const multipleFiles: IFileListDisplayItemPayload[] = [];
          idList.forEach(function(id, index) {
            const newFile: IFileListDisplayItemPayload = {} as IFileListDisplayItemPayload;
            newFile.payloadId = id;
            newFile.payloadName = nameList[index];
            multipleFiles.push(newFile);
          });
          multipleFiles.sort(function(a, b) {
            const nameA = a.payloadName.toLowerCase(),
              nameB = b.payloadName.toLowerCase();
            if (nameA < nameB)
              //sort string ascending
              return -1;
            if (nameA > nameB) return 1;
            return 0; //default return value (no sorting)
          });
          multipleFiles.forEach(multipleFile => {
            const itemFile: IFileListDisplayItemPayload = {} as IFileListDisplayItemPayload;
            itemFile.payloadId = multipleFile.payloadId;
            itemFile.payloadName = multipleFile.payloadName;
            taskItem.fileList.push(itemFile);
            itemFile.ebbModifiedByTypeOptionSet =
              item.ebbModifiedByTypeOptionSet;
            if (item.annotations) {
              const annotation = item.annotations.find(
                x => x.id === multipleFile.payloadId.toString()
              );
              if (annotation) {
                itemFile.ebbModifiedDate = annotation.modifiedOn;
              } else {
                itemFile.ebbModifiedDate = item.ebbModifiedDate;
              }
            }
          });
        } else {
          const itemFile: IFileListDisplayItemPayload = {} as IFileListDisplayItemPayload;
          itemFile.payloadId = item.payload;
          itemFile.payloadName = item.payloadName;
          itemFile.ebbModifiedByTypeOptionSet = item.ebbModifiedByTypeOptionSet;
          if (item.payload && item.payload.length > 0) {
            if (item.annotations) {
              const annotation = item.annotations.find(
                x => x.id === item.payload.toString()
              );
              if (annotation) {
                itemFile.ebbModifiedDate = annotation.modifiedOn;
              } else {
                itemFile.ebbModifiedDate = item.ebbModifiedDate;
              }
            }
          }
          itemFile.payloadId && itemFile.payloadId.length > 0
            ? taskItem.fileList.push(itemFile)
            : (taskItem.fileList = []);
        }
        ret.push(item);
        this.taskList.push(taskItem);
      }
    });

    return ret;
  }

  private setApprovalTask(
    _approvalTaskItem: IApprovalTaskItem,
    annotation: IAnnotationInput
  ): IApprovalTaskItem {
    let idList = [];
    let nameList = [];
    var approvalTaskItem = cloneDeep(_approvalTaskItem);
    //build list
    if (approvalTaskItem.payload) {
      if (approvalTaskItem.payload.indexOf(',') > 0) {
        idList = approvalTaskItem.payload.split(',');
        nameList = approvalTaskItem.payloadName.split(',');
      } else {
        idList.push(approvalTaskItem.payload);
        nameList.push(approvalTaskItem.payloadName);
      }
    }

    //find index
    const index = idList.findIndex(val => {
      return val === annotation.id;
    });

    if (index > -1) {
      nameList[index] = annotation.fileName;
    } else {
      idList.push(annotation.id);
      nameList.push(annotation.fileName);
    }

    approvalTaskItem.payload = idList.join();
    approvalTaskItem.payloadName = nameList.join();

    return approvalTaskItem;
  }

  /***     User Convenience Methods */
  public isHomeowner() : boolean {
    return this.authenticationService.isHomeowner(this.currentUser);
  }

  public isContractor(): boolean {
    return this.authenticationService.isContractor(this.currentUser);
  }

  // onCheckSaveUpdate(id: string): boolean {
  //   let retVal = true;
  //   const indexToUpdate = this.taskListUpdate.findIndex(i => i.id === id);
  //   if (this.taskListUpdate[indexToUpdate].disabled === false) {
  //     retVal = false;
  //   }
  //   return retVal;
  // }
}
